query teamOverlayAttributeKeys {
  teamOverlayAttributeKeys {
    key
    label
    kind
    powerOrAdminOnly
  }
}
